<template lang="">
    <div v-if="loading" class="loading-overlay">
        <div class="spinner"></div>
        Loading...
    </div>
    <div class="container-fluid py-5">
        <div class="scan-mode box top-box mb-3 p-4 rounded-3 bg-white d-flex align-items-center shadow">
            <p class="font-weight-bold text-h4">Scan Parts</p>
        </div>
        
        
        <!-- <h4 class="mb-3 ml-5 mt-3">TRANSACTION REQUEST</h4>
            <v-divider></v-divider> -->
        <div class="justify-content-between d-flex">
            <div class="d-flex">           
                <!-- <p class="scan-mode black border shadow bg-white rounded pa-2 font-weight-bold mt-3 mr-3">Offsite No: {{ this.offsetNo }}</p> -->
                <div class="d-flex ml-10 mr-10">
                    <p class="font-weight-bold mt-3 mr-2">Packing List Scan: </p>
                    <v-text-field ref="ordNoInput" v-model="ordNoInput" hide-details="auto" id="barcode-scanner"
                        @keyup.enter="scanOrdNo"></v-text-field>

                </div>
                <p class="scan-mode d-flex align-center shadow bg-white black border rounded pa-2 font-weight-bold mt-3 mr-3"><i class="material-symbols-outlined opacity-10 mr-1">barcode_scanner</i>ORD NO: {{ this.ordNo }}</p>
                <p class="scan-mode d-flex align-center shadow bg-white black border rounded pa-2 font-weight-bold mt-3 mr-3" :class="`${this.scannedPart === this.totalQty ? 'text-white bg-green' : ''}`"><i class="material-symbols-outlined opacity-10 mr-1">barcode_scanner</i>Total Scanned Parts: {{ this.scannedPart }}/{{ this.totalQty }}</p>

                <p class="scan-mode scan-mode-button black border shadow bg-white rounded pa-2 mt-3 mr-3 font-weight-bold" @click="hideSidebar">
                    <v-icon icon="mdi-barcode-scan" class="mr-2 "></v-icon>SCAN MODE
                </p>
                <!-- <input type="radio" id="plant1" value="50101" v-model="picked" />
                <label for="plant1">Plant 1</label>

                <input type="radio" id="plant2" value="50102" v-model="picked" />
                <label for="plant2">Plant 2</label> -->

                <v-radio-group v-model="pick" class="radio-group-horizontal" inline>
                    <v-radio label="Plant 1" value="50101" class="custom-radio" style="white-space: nowrap !important; color: white; display: inline-block;"></v-radio>
                    <v-radio label="Plant 2" value="50102" class="custom-radio" style="white-space: nowrap !important; color: white; display: inline-block;"></v-radio>
                    
                </v-radio-group>
                <v-btn class="mt-5 ml-3 mr-6 bg-red" @click="fetchMobis" size="x-large">MOBIS</v-btn>
                <v-btn :class="['mt-5', 'ml-3', 'mr-6', buttonClass]" @click="setLp" size="x-large">LP</v-btn>
            </div>
            <div v-if="totalQty === scannedPart" class="d-flex">
                <v-btn v-if="submitStatus == 1" class="mt-3 mr-6 bg-green" @click="saveReceivingPerformance">SUBMIT</v-btn>
            </div>
            
        </div>
        
        
        <div class="d-flex">
            <v-card class="mt-1 mr-3 w-70 custom-card scan-mode">
        
                <v-tabs v-model="tab" color="deep-purple-accent-4">
                    <v-tab value="1">Scan Table</v-tab>
                    <!-- <v-tab value="2">Shipping</v-tab> -->
                    <!-- <v-tab value="9">Completed</v-tab> -->
                </v-tabs>
                

                <v-card-text>
                    <v-window v-model="tab">
                        <v-window-item value="1">
                            <v-data-table
                                :items-per-page="itemsPerPage"
                                :headers="headers"
                                :items="partList"
                                density="compact"
                                item-value="name"
                                class="text-h3 scan-mode font-weight-black"
                                >
                                <!-- <template v-slot:top>
                            
                                </template> -->

<template #[`item`]="{ item }">
                                    <tr class="data-table-row font-weight-bold">
                                        <td>{{ partList.indexOf(item) + 1 }}</td>
                                        <td v-if="isNumericChar(item.ITMNO.charAt(0))" class="custom-class text-center font-weight-black text-h3">{{ item.ITMNO.substring(0,5) + '-' + item.ITMNO.substring(5) }}</td>
                                        <td v-if="!isNumericChar(item.ITMNO.charAt(0))" class="custom-class text-center font-weight-black text-h3">{{ item.ITMNO.substring(0,6) + '-' + item.ITMNO.substring(6) }}</td>
                                        <td class="text-center font-weight-black text-h3">{{ item.BOX2_QTY.toLocaleString() }}</td>
                                        <td class="text-center font-weight-black text-h3">{{ item.SCANNED_QTY.toLocaleString() }}</td>
                                        <td class="text-center">
                                        <v-chip
                                            :color="item.SCAN_STATUS === '0' ? 'red' : 'green'"
                                            class="text-uppercase text-h4"
                                            variant="flat"
                                            label
                                            size="big"
                                        >
                                            {{ item.SCAN_STATUS === '0' ? 'Not Scanned' : 'Scanned' }}
                                        </v-chip>
                                        </td>
                                    </tr>
                                </template>

</v-data-table>
</v-window-item>

</v-window>
</v-card-text>
</v-card>
<v-card class="mt-1 w-30 scan-mode">
    <v-tabs v-model="tab" color="deep-purple-accent-4">
        <v-tab value="1">Scan Status</v-tab>
        <!-- <v-tab value="2">Shipping</v-tab> -->
        <!-- <v-tab value="9">Completed</v-tab> -->
    </v-tabs>
    <v-card-text>
        <v-window class="h-100" v-model="tab">
            <v-window-item value="1">
                <div class="border rounded ma-3 mw-90 h-75 scan-screen justify-center align-center">
                    <v-row class="fill-height" align="center" justify="center">
                        <v-col cols="12" class="d-flex justify-center align-center custom-height">
                            <p class="text-white font-weight-bold custom-text status-text" id="status-text"></p>
                        </v-col>
                        <v-col cols="12" class="d-flex justify-center align-center custom-height" id="status-box">
                            <p class="text-white font-weight-bold text-h2" id="status-text2"></p>
                        </v-col>
                    </v-row>


                </div>

                <div v-if="totalQty !== scannedPart" class="d-flex ml-10 mr-10">
                    <p class="font-weight-bold mt-3 mr-2">barcode scan: </p>
                    <v-text-field ref="barcodeInput" v-model="barcodeInput" hide-details="auto" id="barcode-scanner"
                        @keyup.enter="scanBarcode"></v-text-field>

                </div>
            </v-window-item>
        </v-window>
    </v-card-text>

</v-card>
</div>
<SelectMobisContModal v-if="isModalVisible" :products="fetchedData" @submit-products="fetchMobisData"
    @close-modal="isModalVisible = false" />
</div>
</template>
<script>
import axios from 'axios';
import { mapState } from 'vuex';
import SelectMobisContModal from '@/components/Ui/SelectMobisContModal.vue';
// import { ref, onMounted } from 'vue';
// const inputRef = ref(null);

// onMounted(() => {
//     inputRef.value.focus();
// })
export default {
    components: {
        SelectMobisContModal
    },
    data() {
        return {
            itemsPerPage: 100,
            containerNo: '',
            partList: [],
            submitStatus: 0,
            isModalVisible: false,
            headers: [
                {
                    title: 'No',
                    align: 'start',
                    sortable: false,
                    class: 'with-divider',
                    key: ''
                },
                {
                    title: 'ITEM No',
                    align: 'center',
                    sortable: false,
                    class: 'with-divider',
                    key: 'ITMNO'
                },
                {
                    title: 'Qty',
                    align: 'center',
                    sortable: false,
                    class: 'with-divider',
                    key: 'BOX2_QTY'
                },
                {
                    title: 'Scan Qty',
                    align: 'center',
                    sortable: false,
                    class: 'with-divider',
                    key: 'SCANNED_QTY'
                },
                {
                    title: 'Status',
                    align: 'center',
                    sortable: false,
                    class: 'with-divider',
                    key: 'SCAN_STATUS'
                }
            ],
            tab: null,
            scannedPart: 0,
            totalQty: 0,
            barcodeInput: '',
            ordNoInput: '',
            scanCheck: false,
            totalScanComplete: false,
            loading: false,
            offStatus: '',
            destination: '',
            offsetIdx: '',
            estimatedDate: '',
            isFinished: false,
            originPartList: [],
            receivingType: '',
            pick: '50101',
            fetchedData: [],
            isMobis: false,
            isLp: false,
            status8: 0,
            ordNo: '',
            indate: '',
        }
    },
    computed: {
        ...mapState({
            username: state => state.username
        }),
        buttonClass() {
            return this.isLp ? 'bg-blue' : 'bg-white'
        }
    },
    props: {
        offsetNo: {
            type: String,
            required: true,
        },
        contNo: {
            type: String,
            required: true,
        }
    },
    async mounted() {
        this.loading = true;
        await this.hideSidebar();
        this.$nextTick(() => {
            if (this.$refs.ordNoInput) {
                this.$refs.ordNoInput.focus();
            }
        });
        //console.log(this.username);
        if (this.username == '3000033') {
            this.pick = '50102';
        }
        const now = new Date();

        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");
        const seconds = String(now.getSeconds()).padStart(2, "0");

        this.indate = `${year}${month}${day}${hours}${minutes}${seconds}`
        this.loading = false;

    },
    methods: {
        async setLp() {
            this.isLp = !this.isLp;
            //console.log(this.pick);
            //console.log(this.isLp);
        },
        async fetchMobisData(data) {
            this.loading = true;
            try {
                this.originPartList = [];
                this.scannedPart = 0;

                if (data.length != 0) {
                    const response = await axios.get('/api/getReceivingPartsByInvoCont', {
                        params: {
                            invoNo: data.INVO_NO,
                            contNo: data.CONT_NO
                        }
                    });
                    if (response) {
                        this.originPartList = response.data;
                        //console.log(this.originPartList);
                        let tempList = [];
                        for (let part of response.data) {
                            if (!Object.hasOwnProperty.call(tempList, part.ITMNO.trim())) {
                                if (part.STATUS == '9' || part.STATUS == '8') {
                                    tempList[part.ITMNO.trim()] = {
                                        'ITMNO': part.ITMNO.trim(),
                                        'BOX2_QTY': part.BOX2_QTY,
                                        'SCANNED_QTY': part.BOX2_QTY,
                                        'SCAN_STATUS': '0',
                                        'CUST_CD': part.CUST_CD
                                    }
                                } else {
                                    tempList[part.ITMNO.trim()] = {
                                        'ITMNO': part.ITMNO.trim(),
                                        'BOX2_QTY': part.BOX2_QTY,
                                        'SCANNED_QTY': 0,
                                        'SCAN_STATUS': '0',
                                        'CUST_CD': part.CUST_CD
                                    }
                                }

                            } else {
                                if (part.STATUS == '9') {
                                    this.submitStatus = '2'
                                    tempList[part.ITMNO.trim()].SCANNED_QTY += part.BOX2_QTY;
                                } else {
                                    if (part.STATUS == '8') {
                                        tempList[part.ITMNO.trim()].SCANNED_QTY += part.BOX2_QTY;
                                    }
                                    this.submitStatus = '1'
                                }
                                tempList[part.ITMNO.trim()].BOX2_QTY += part.BOX2_QTY;
                            }
                        }
                        let totalScanned = true;
                        for (let part of Object.values(tempList)) {
                            if (part.BOX2_QTY == part.SCANNED_QTY) {
                                part.SCAN_STATUS = '1'
                                this.scannedPart += 1;
                            } else {
                                totalScanned = false;
                            }
                        }

                        this.partList = Object.values(tempList);
                        //console.log(this.originPartList);
                        this.totalQty = this.originPartList.length
                        if (totalScanned) {
                            this.scannedPart = this.totalQty
                        }
                        this.isMobis = true;
                    } else {
                        alert("Getting receiving part is failed");
                    }
                }
            } catch (err) {
                console.error("Fetch mobis data is failed");
                alert("Fetch mobis data is failed");
            }
            this.loading = false;
        },
        async fetchMobis() {
            this.loading = true;
            try {
                const response = await axios.get('/api/getMobisContNoInvoNo');
                this.fetchedData = response.data;
                this.isModalVisible = true;
            } catch (err) {
                console.error('Mobis Fetch error: ', err);
                alert('Mobis Fetch error: ', err);
                this.isModalVisible = false;
            }
            this.loading = false;
        },
        async hideSidebar() {
            this.loading = true;
            const sidenavShow = document.getElementsByClassName("sidenav")[0];
            const mainContent = document.getElementsByClassName("main-content")[0];
            const specificContents = document.getElementsByClassName('scan-mode');
            if (sidenavShow.classList.contains("hide-sidebar")) {
                sidenavShow.classList.remove("hide-sidebar");
                mainContent.classList.remove("maximize-content");
                for (const content of specificContents) {
                    if (!content.classList.contains("bg-white")) {
                        content.classList.add("bg-white")
                    }
                    if (!content.classList.contains("border")) {
                        content.classList.add("border");
                    }
                    content.classList.remove("bg-black");
                    content.classList.remove("on-scan");
                }
            } else {
                for (const content of specificContents) {
                    await content.classList.add("bg-black");
                    content.classList.add("on-scan");
                    if (content.classList.contains("bg-white")) {
                        content.classList.remove("bg-white");
                    }
                    if (content.classList.contains("border")) {
                        content.classList.remove("border");
                    }

                }
                sidenavShow.classList.add("hide-sidebar");
                mainContent.classList.add("maximize-content");

            }
            this.loading = false;

        },
        async saveReceivingPerformance() {
            this.loading = true;
            let submitPartList = [];
            let warhs = '';
            const now = new Date();

            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const trsdt = year + month + day;
            const ref02 = this.username + '-' + this.indate;
            if (this.pick == '50101') {
                warhs = 'AB'
            } else {
                warhs = 'BB'
            }
            let serno = 1;
            for (const part of this.originPartList) {
                // for (const part of this.partList) {
                let tempPart = {};
                let itmno = '';
                if (this.isNumericChar(part.ITMNO.charAt(0))) {
                    itmno = part.ITMNO.substring(0, 5) + '-' + part.ITMNO.substring(5)
                } else {
                    itmno = part.ITMNO.substring(0, 6) + '-' + part.ITMNO.substring(6)
                }
                if (part.STATUS == '8' || part.STATUS == '9') {
                    // if (part.SCAN_STATUS == '1') {
                    tempPart = {
                        'ITMNO': itmno,
                        'WARHS': warhs,
                        'TRSCD': 'RM',
                        'TRSDT': trsdt,
                        'SERNO': serno,
                        'QUNTY': part.BOX2_QTY,
                        'WEIGHT': 0,
                        'MONEY': 0,
                        'TRGAE': warhs,
                        'LOCAT': '',
                        'LOTNO': part.BOX_LOT,
                        'CSTCD': part.CUST_CD,
                        'REF01': this.pick,
                        'REF02': ref02,
                        'STATS': '1',
                        'FILL': '',

                    }
                    submitPartList.push(tempPart);
                }

                serno++;
            }
            //console.log(submitPartList);
            const response = await axios.post('/api/saveReceivingPerformance', {
                partData: submitPartList
            });
            if (response.data.success) {
                const res1 = await axios.post('/api/completePartStatus', {
                    partData: this.originPartList,
                    receivingType: this.receivingType,
                    ordNo: this.ordNo
                })
                if (res1.data.success) {
                    alert("Successfully Saved");
                    if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-failed')) {
                        document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-failed');
                    }
                    if (!document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-success')) {
                        document.getElementsByClassName('scan-screen')[0].classList.add('custom-scan-success')
                    }
                    document.getElementsByClassName('status-text')[0].classList.remove('custom-text');
                    document.getElementsByClassName('status-text')[0].classList.add('custom-text-2');
                    document.getElementById("status-text").innerText = "COMPLETE";
                    document.getElementById("status-text2").innerText = "";

                    // document.getElementById("status-box").classList.add("success-screen-part");

                }

            }
            this.isMobis = false;
            this.originPartList = [];
            this.partList = [];
            this.isLp = false;
            this.$nextTick(() => {
                if (this.$refs.ordNoInput) {
                    this.$refs.ordNoInput.focus();
                }
            });
            this.loading = false;
        },
        async scanBarcode() {
            this.loading = true;
            // const controlChars = {
            //     29: '*',
            //     4: 'EOT',
            //     30: ':'
            // }
            if (this.isMobis) {
                let mobisScannedList = [];
                let scanData = {};
                let errorMsg = ''
                let mobisScannedTotalList = [];
                //console.log(this.originPartList);
                for (const part of this.originPartList) {
                    if (part.BOX_QR === this.barcodeInput.toUpperCase()) {
                        if (part.STATUS !== '8' && part.STATUS !== '9') {
                            scanData = part;
                            scanData.STATUS = '8';

                            mobisScannedList.push(scanData);
                            if (!Object.hasOwnProperty.call(mobisScannedTotalList, part.ITMNO.trim())) {
                                mobisScannedTotalList[scanData.ITMNO.trim()] = {
                                    'ITMNO': scanData.ITMNO.trim(),
                                    'BOX2_QTY': scanData.BOX2_QTY
                                }
                            } else {
                                mobisScannedTotalList[scanData.ITMNO.trim()].BOX2_QTY += scanData.BOX2_QTY;
                            }


                        }
                    }
                }
                if (mobisScannedList.length > 0) {
                    this.scanCheck = true;
                } else {
                    errorMsg = 'Already scanned';
                    this.scanCheck = false;
                }
                if (this.scanCheck) {
                    try {
                        //console.log(mobisScannedList);
                        for (let part of mobisScannedList) {
                            const response = await axios.post('/api/saveScanData', {
                                partData: part,
                                sabun: this.username,
                                locat: this.pick
                            });
                            if (response.data.success) {
                                this.scanCheck = true;
                            } else {
                                this.scanCheck = false;
                            }


                        }
                        for (let part of this.partList) {

                            if (Object.hasOwnProperty.call(mobisScannedTotalList, part.ITMNO.trim())) {

                                part.SCANNED_QTY += mobisScannedTotalList[part.ITMNO.trim()].BOX2_QTY;
                                if (part.SCANNED_QTY == part.BOX2_QTY) {
                                    part.SCAN_STATUS = '1';
                                }
                                this.scannedPart += 1;
                            } else {
                                if (part.SCANNED_QTY == part.BOX2_QTY) {
                                    part.SCAN_STATUS = '1';

                                }
                            }
                        }
                        if (this.scanCheck) {
                            if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-failed')) {
                                document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-failed');
                            }
                            // Add this part to play the audio file
                            const audio = new Audio(require('@/assets/OK.wav'));
                            audio.play();
                            document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-success");
                            document.getElementById("status-text").innerText = "OK";
                            document.getElementById("status-box").classList.add("success-screen-part");
                            if (this.isNumericChar(scanData.ITMNO.charAt(0))) {
                                document.getElementById("status-text2").innerText = scanData.ITMNO.substring(0, 5) + '-' + scanData.ITMNO.substring(5)
                            } else {
                                document.getElementById("status-text2").innerText = scanData.ITMNO.substring(0, 6) + '-' + scanData.ITMNO.substring(6)
                            }

                        } else {
                            if (errorMsg.length == 0) {
                                errorMsg = 'Saving scan data is failed';
                            }
                            if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-success')) {
                                document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-success');
                            }
                            const audio = new Audio(require('@/assets/NG.wav'));
                            audio.play();
                            document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-failed");
                            document.getElementById("status-text").innerText = "NG";
                            document.getElementById("status-box").classList.add("success-screen-part");
                            document.getElementById("status-text2").innerText = errorMsg + "";
                            errorMsg = ""

                        }
                        if (this.totalQty == this.scannedPart) {

                            await this.saveReceivingPerformance();
                            this.submitStatus = 2;
                        }
                    } catch (err) {
                        console.error('Scan data save error: ', err);
                        if (errorMsg.length == 0) {
                            errorMsg = 'Scan data save error';
                        }
                        if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-success')) {
                            document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-success');
                        }
                        const audio = new Audio(require('@/assets/NG.wav'));
                        audio.play();
                        document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-failed");
                        document.getElementById("status-text").innerText = "NG";
                        document.getElementById("status-box").classList.add("success-screen-part");
                        document.getElementById("status-text2").innerText = errorMsg + "";
                        errorMsg = ""
                    }
                } else {
                    if (errorMsg.length == 0) {
                        errorMsg = 'No matched data';
                    }
                    if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-success')) {
                        document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-success');
                    }
                    const audio = new Audio(require('@/assets/NG.wav'));
                    audio.play();
                    document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-failed");
                    document.getElementById("status-text").innerText = "NG";
                    document.getElementById("status-box").classList.add("success-screen-part");
                    document.getElementById("status-text2").innerText = errorMsg + "";
                    errorMsg = ""

                }
            } else if (this.isLp) {

                let errorMsg = ""
                if (this.barcodeInput.toUpperCase().includes('1M') || this.barcodeInput.toUpperCase().includes('2M') || this.barcodeInput.toUpperCase().includes('7M')) {
                    const response1 = await axios.get('/api/dupMobisScanChk', {
                        params: {
                            partData: this.barcodeInput.toUpperCase()
                        }

                    });
                    const dupMobisScanChk = response1.data;
                    if (dupMobisScanChk) {
                        errorMsg = 'Already scanned';
                        if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-success')) {
                            document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-success');
                        }
                        const audio = new Audio(require('@/assets/NG.wav'));
                        audio.play();
                        document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-failed");
                        document.getElementById("status-text").innerText = "NG";
                        document.getElementById("status-box").classList.add("success-screen-part");
                        document.getElementById("status-text2").innerText = errorMsg + "";
                        errorMsg = ""
                    } else {
                        const response = await axios.get('/api/getPartsByBigcode', {
                            params: {
                                partData: this.barcodeInput.toUpperCase(),
                            }
                        });
                        //console.log(response.data)
                        if (response) {
                            for (const part of response.data) {

                                let tempJson = {
                                    'GUBN': 'A',
                                    'INVO_NO': this.ordNo,
                                    'CONT_NO': this.ordNo,
                                    'ITMNO': part.ITMNO.toUpperCase(),
                                    'BOX_LOT': part.LOTNO,
                                    'BOX2_QTY': part.BOX2_QTY,
                                    'BOX2_QR': part.BOX2_QR,
                                    'CUST_CD': part.ST_CUST_CD,
                                    'BIG_CODE': part.BOX_QR,
                                    'INDATE': '',
                                    'SABUN': this.username,
                                    'LOCAT': this.pick,

                                }
                                let itmCheck = false;
                                let fullyScanned = false;
                                for (const part of this.partList) {
                                    if (part.ITMNO.trim().toUpperCase() == tempJson.ITMNO.trim().toUpperCase()) {
                                        itmCheck = true;
                                        part.SCANNED_QTY += tempJson.BOX2_QTY;
                                        if (part.SCANNED_QTY == part.BOX2_QTY) {
                                            part.SCAN_STATUS = '1';
                                            fullyScanned = true;
                                        }
                                        break;
                                    }
                                }
                                if (itmCheck) {
                                    const res1 = await axios.post('/api/saveB2bMobisData', {
                                        partData: tempJson
                                    });
                                    if (res1.data.success) {
                                        let tempPartData = {};
                                        for (const part of this.originPartList) {
                                            //console.log(part);
                                            if (part.ITMNO.trim().toUpperCase() == tempJson.ITMNO.trim().toUpperCase() && part.STATUS == '7' && fullyScanned) {

                                                part.STATUS = '8';
                                                tempPartData = part;
                                                break;
                                            }
                                        }
                                        if (fullyScanned) {
                                            const res2 = await axios.post('/api/updateLpData', {
                                                originalPartData: tempPartData
                                            })
                                            // if (fullyScanned){
                                            if (res2.data.success) {
                                                //console.log("successfully saved2");
                                                if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-failed')) {
                                                    document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-failed');
                                                }
                                                // Add this part to play the audio file
                                                const audio = new Audio(require('@/assets/OK.wav'));
                                                audio.play();
                                                document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-success");
                                                document.getElementById("status-text").innerText = "OK";
                                                document.getElementById("status-box").classList.add("success-screen-part");
                                                if (this.isNumericChar(tempJson.ITMNO.charAt(0))) {
                                                    document.getElementById("status-text2").innerText = tempJson.ITMNO.substring(0, 5) + '-' + tempJson.ITMNO.substring(5)
                                                } else {
                                                    document.getElementById("status-text2").innerText = tempJson.ITMNO.substring(0, 6) + '-' + tempJson.ITMNO.substring(6)
                                                }

                                                this.scannedPart += 1;
                                            } else {
                                                if (errorMsg.length == 0) {
                                                    errorMsg = 'Saving scan data is failed';
                                                }
                                                if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-success')) {
                                                    document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-success');
                                                }
                                                const audio = new Audio(require('@/assets/NG.wav'));
                                                audio.play();
                                                document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-failed");
                                                document.getElementById("status-text").innerText = "NG";
                                                document.getElementById("status-box").classList.add("success-screen-part");
                                                document.getElementById("status-text2").innerText = errorMsg + "";
                                                errorMsg = ""
                                            }
                                        } else {
                                            if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-failed')) {
                                                document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-failed');
                                            }
                                            // Add this part to play the audio file
                                            const audio = new Audio(require('@/assets/OK.wav'));
                                            audio.play();
                                            document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-success");
                                            document.getElementById("status-text").innerText = "OK";
                                            document.getElementById("status-box").classList.add("success-screen-part");
                                            if (this.isNumericChar(tempJson.ITMNO.charAt(0))) {
                                                document.getElementById("status-text2").innerText = tempJson.ITMNO.substring(0, 5) + '-' + tempJson.ITMNO.substring(5)
                                            } else {
                                                document.getElementById("status-text2").innerText = tempJson.ITMNO.substring(0, 6) + '-' + tempJson.ITMNO.substring(6)
                                            }
                                        }

                                    }
                                    if (this.totalQty == this.scannedPart) {
                                        await this.saveReceivingPerformance();
                                        this.submitStatus = 2;
                                    }

                                }

                            }
                        }
                    }

                } else {
                    let tempBarcode = this.barcodeInput.split(':');
                    //console.log(tempBarcode);
                    let itmno = '';
                    let lotno = '';
                    let qty = 0;
                    let custCd = '';
                    for (const data of tempBarcode) {
                        if (data.charAt(0).toUpperCase() == 'P') {
                            itmno = data.substring(1);
                            itmno = itmno.replace('-', '');
                        } else if (data.substring(0, 2).toUpperCase() == '7Q') {
                            qty = parseInt(data.substring(2));
                        } else if (data.charAt(0).toUpperCase() == 'D') {
                            lotno = data.substring(1);
                            lotno = lotno.replace('/', '');
                            if (lotno.length == 6) {
                                if (parseInt(lotno.substring(0, 2)) > 12) {
                                    lotno = "20" + lotno;
                                } else {
                                    lotno = "20" + lotno.substring(4) + lotno.substring(0, 4);
                                }
                            }
                        } else if (data.substring(0, 3).toUpperCase() == '24L') {
                            custCd = data.toUpperCase().replace('24L', '').trim();
                        }
                    }
                    let tempJson = {
                        'GUBN': 'A',
                        'INVO_NO': this.ordNo,
                        'CONT_NO': this.ordNo,
                        'ITMNO': itmno.toUpperCase(),
                        'BOX_LOT': lotno,
                        'BOX2_QTY': qty,
                        'BOX2_QR': this.barcodeInput.toUpperCase(),
                        'CUST_CD': custCd,
                        'BIG_CODE': '',
                        'INDATE': '',
                        'SABUN': this.username,
                        'LOCAT': this.pick,

                    }
                    const res1 = await axios.get('/api/dupScanChk', {
                        params: {
                            partData: tempJson
                        }
                    });
                    const dupChk = res1.data;
                    if (dupChk) {
                        errorMsg = 'Already scanned';
                        if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-success')) {
                            document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-success');
                        }
                        const audio = new Audio(require('@/assets/NG.wav'));
                        audio.play();
                        document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-failed");
                        document.getElementById("status-text").innerText = "NG";
                        document.getElementById("status-box").classList.add("success-screen-part");
                        document.getElementById("status-text2").innerText = errorMsg + "";
                        errorMsg = ""
                    } else {
                        let itmCheck = false;
                        let fullyScanned = false;
                        for (const part of this.partList) {
                            if (part.ITMNO.trim().toUpperCase() == tempJson.ITMNO.trim().toUpperCase()) {
                                itmCheck = true;
                                part.SCANNED_QTY += tempJson.BOX2_QTY;
                                if (part.SCANNED_QTY == part.BOX2_QTY) {
                                    part.SCAN_STATUS = '1';
                                    fullyScanned = true;
                                }
                                break;
                            }
                        }

                        if (itmCheck) {
                            //console.log(this.partList);
                            //console.log(tempJson);
                           
                            tempJson.INDATE = this.indate;
                            const response = await axios.post('/api/saveLpScanData', {
                                partData: tempJson,
                            });
                            if (response.data.success) {
                                let tempPartData = {};
                                for (const part of this.originPartList) {
                                    //console.log(part);
                                    if (part.ITMNO.trim().toUpperCase() == tempJson.ITMNO.trim().toUpperCase() && part.STATUS == '7' && fullyScanned) {

                                        part.STATUS = '8';
                                        tempPartData = part;
                                        break;
                                    }
                                }
                                //console.log("successfully saved1");
                                //console.log(tempPartData)
                                if (fullyScanned) {
                                    const res2 = await axios.post('/api/updateLpData', {
                                        originalPartData: tempPartData
                                    })
                                    // if (fullyScanned){
                                    if (res2.data.success) {
                                        //console.log("successfully saved2");
                                        if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-failed')) {
                                            document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-failed');
                                        }
                                        // Add this part to play the audio file
                                        const audio = new Audio(require('@/assets/OK.wav'));
                                        audio.play();
                                        document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-success");
                                        document.getElementById("status-text").innerText = "OK";
                                        document.getElementById("status-box").classList.add("success-screen-part");
                                        if (this.isNumericChar(tempJson.ITMNO.charAt(0))) {
                                            document.getElementById("status-text2").innerText = tempJson.ITMNO.substring(0, 5) + '-' + tempJson.ITMNO.substring(5)
                                        } else {
                                            document.getElementById("status-text2").innerText = tempJson.ITMNO.substring(0, 6) + '-' + tempJson.ITMNO.substring(6)
                                        }

                                        this.scannedPart += 1;
                                    } else {
                                        if (errorMsg.length == 0) {
                                            errorMsg = 'Saving scan data is failed';
                                        }
                                        if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-success')) {
                                            document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-success');
                                        }
                                        const audio = new Audio(require('@/assets/NG.wav'));
                                        audio.play();
                                        document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-failed");
                                        document.getElementById("status-text").innerText = "NG";
                                        document.getElementById("status-box").classList.add("success-screen-part");
                                        document.getElementById("status-text2").innerText = errorMsg + "";
                                        errorMsg = ""
                                    }
                                } else {
                                    if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-failed')) {
                                        document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-failed');
                                    }
                                    // Add this part to play the audio file
                                    const audio = new Audio(require('@/assets/OK.wav'));
                                    audio.play();
                                    document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-success");
                                    document.getElementById("status-text").innerText = "OK";
                                    document.getElementById("status-box").classList.add("success-screen-part");
                                    if (this.isNumericChar(tempJson.ITMNO.charAt(0))) {
                                        document.getElementById("status-text2").innerText = tempJson.ITMNO.substring(0, 5) + '-' + tempJson.ITMNO.substring(5)
                                    } else {
                                        document.getElementById("status-text2").innerText = tempJson.ITMNO.substring(0, 6) + '-' + tempJson.ITMNO.substring(6)
                                    }
                                }


                            } else {
                                if (errorMsg.length == 0) {
                                    errorMsg = 'Saving scan data is failed';
                                }
                                if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-success')) {
                                    document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-success');
                                }
                                const audio = new Audio(require('@/assets/NG.wav'));
                                audio.play();
                                document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-failed");
                                document.getElementById("status-text").innerText = "NG";
                                document.getElementById("status-box").classList.add("success-screen-part");
                                document.getElementById("status-text2").innerText = errorMsg + "";
                                errorMsg = ""
                            }
                            if (this.totalQty == this.scannedPart) {

                                await this.saveReceivingPerformance();
                                this.submitStatus = 2;
                            }
                        } else {
                            if (errorMsg.length == 0) {
                                errorMsg = 'No matched Data';
                            }
                            if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-success')) {
                                document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-success');
                            }
                            const audio = new Audio(require('@/assets/NG.wav'));
                            audio.play();
                            document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-failed");
                            document.getElementById("status-text").innerText = "NG";
                            document.getElementById("status-box").classList.add("success-screen-part");
                            document.getElementById("status-text2").innerText = errorMsg + "";
                            errorMsg = ""
                        }
                    }
                }

            } else {
                let scanData = {};
                let scanDataIdx = 0;
                let errorMsg = ''
                for (const part of this.originPartList) {
                    if (part.BOX1_QR == this.barcodeInput.toUpperCase() || part.BOX2_QR == this.barcodeInput.toUpperCase()) {

                        if (part.STATUS == '8' || part.STATUS == '9') {
                            errorMsg = 'Already scanned';
                            this.scanCheck = false;
                        } else {
                            scanData = part;
                            this.scanCheck = true;
                        }

                        break;

                    }
                    scanDataIdx += 1;
                }
                const bigBoxCount = this.originPartList.filter(part => part.BOX1_QR === this.barcodeInput.toUpperCase()).length;
                if (this.scanCheck) {
                    try {
                        if (bigBoxCount > 1) {
                            for (let part of this.partList) {

                                if (part.ITMNO.trim() == scanData.ITMNO.trim()) {
                                    //console.log(part);
                                    part.SCANNED_QTY += scanData.BOX1_QTY;
                                    if (part.SCANNED_QTY == part.BOX2_QTY) {
                                        part.SCAN_STATUS = '1';
                                    }
                                }
                            }
                            const response = await axios.post('/api/saveScanData', {
                                partData: scanData,
                                sabun: this.username,
                                locat: this.pick,
                                isBig: true,
                            });
                            if (response.data.success) {
                                // if (this.scanCheck) {
                                if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-failed')) {
                                    document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-failed');
                                }
                                // Add this part to play the audio file
                                const audio = new Audio(require('@/assets/OK.wav'));
                                audio.play();
                                document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-success");
                                document.getElementById("status-text").innerText = "OK";
                                document.getElementById("status-box").classList.add("success-screen-part");
                                if (this.isNumericChar(scanData.ITMNO.charAt(0))) {
                                    document.getElementById("status-text2").innerText = scanData.ITMNO.substring(0, 5) + '-' + scanData.ITMNO.substring(5)
                                } else {
                                    document.getElementById("status-text2").innerText = scanData.ITMNO.substring(0, 6) + '-' + scanData.ITMNO.substring(6)
                                }

                                this.scannedPart += bigBoxCount;
                                this.originPartList.forEach(part => {
                                    if (part.BOX1_QR === this.barcodeInput.toUpperCase()) {
                                        part.STATUS = '8';
                                    }
                                });
                            } else {
                                if (errorMsg.length == 0) {
                                    errorMsg = 'Saving scan data is failed';
                                }
                                if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-success')) {
                                    document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-success');
                                }
                                const audio = new Audio(require('@/assets/NG.wav'));
                                audio.play();
                                document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-failed");
                                document.getElementById("status-text").innerText = "NG";
                                document.getElementById("status-box").classList.add("success-screen-part");
                                document.getElementById("status-text2").innerText = errorMsg + "";
                                errorMsg = ""
                            }
                            if (this.totalQty == this.scannedPart) {

                                await this.saveReceivingPerformance();
                                this.submitStatus = 2;
                            }
                        } else {
                            for (let part of this.partList) {

                                if (part.ITMNO.trim() == scanData.ITMNO.trim()) {
                                    //console.log(part);
                                    part.SCANNED_QTY += scanData.BOX2_QTY;
                                    if (part.SCANNED_QTY == part.BOX2_QTY) {
                                        part.SCAN_STATUS = '1';
                                    }
                                }
                            }
                            const response = await axios.post('/api/saveScanData', {
                                partData: scanData,
                                sabun: this.username,
                                locat: this.pick,
                                isBig: false,
                            });
                            if (response.data.success) {
                                // if (this.scanCheck) {
                                if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-failed')) {
                                    document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-failed');
                                }
                                // Add this part to play the audio file
                                const audio = new Audio(require('@/assets/OK.wav'));
                                audio.play();
                                document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-success");
                                document.getElementById("status-text").innerText = "OK";
                                document.getElementById("status-box").classList.add("success-screen-part");
                                if (this.isNumericChar(scanData.ITMNO.charAt(0))) {
                                    document.getElementById("status-text2").innerText = scanData.ITMNO.substring(0, 5) + '-' + scanData.ITMNO.substring(5)
                                } else {
                                    document.getElementById("status-text2").innerText = scanData.ITMNO.substring(0, 6) + '-' + scanData.ITMNO.substring(6)
                                }

                                this.scannedPart += 1;

                                this.originPartList[scanDataIdx].STATUS = '8';
                            } else {
                                if (errorMsg.length == 0) {
                                    errorMsg = 'Saving scan data is failed';
                                }
                                if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-success')) {
                                    document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-success');
                                }
                                const audio = new Audio(require('@/assets/NG.wav'));
                                audio.play();
                                document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-failed");
                                document.getElementById("status-text").innerText = "NG";
                                document.getElementById("status-box").classList.add("success-screen-part");
                                document.getElementById("status-text2").innerText = errorMsg + "";
                                errorMsg = ""
                            }
                            if (this.totalQty == this.scannedPart) {

                                await this.saveReceivingPerformance();
                                this.submitStatus = 2;
                            }
                        }

                    } catch (err) {
                        console.error('Scan data save error: ', err);
                        if (errorMsg.length == 0) {
                            errorMsg = 'Scan data save error';
                        }
                        if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-success')) {
                            document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-success');
                        }
                        const audio = new Audio(require('@/assets/NG.wav'));
                        audio.play();
                        document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-failed");
                        document.getElementById("status-text").innerText = "NG";
                        document.getElementById("status-box").classList.add("success-screen-part");
                        document.getElementById("status-text2").innerText = errorMsg + "";
                        errorMsg = ""
                    }
                } else {
                    if (errorMsg.length == 0) {
                        errorMsg = 'No matched data';
                    }
                    const audio = new Audio(require('@/assets/NG.wav'));
                    audio.play();
                    if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-success')) {
                        document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-success');
                    }
                    document.getElementsByClassName("scan-screen")[0].classList.add("custom-scan-failed");
                    document.getElementById("status-text").innerText = "NG";
                    document.getElementById("status-box").classList.add("success-screen-part");
                    document.getElementById("status-text2").innerText = errorMsg + "";
                    errorMsg = ""
                }
            }


            this.barcodeInput = '';
            this.scanCheck = false;
            this.loading = false;
        },
        async scanOrdNo() {
            this.loading = true;
            try {
                if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-failed')) {
                    document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-failed');
                }
                if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-success')) {
                    document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-success')
                }
                document.getElementsByClassName('status-text')[0].classList.remove('custom-text-2');
                document.getElementsByClassName('status-text')[0].classList.add('custom-text');
                document.getElementById("status-text").innerText = "";
                document.getElementById("status-text2").innerText = "";
                this.originPartList = [];
                this.scannedPart = 0;
                this.submitStatus = '0'

                if (this.ordNoInput.trim() != '') {
                    this.ordNo = this.ordNoInput.toUpperCase();
                    if (this.ordNo.charAt(0).toUpperCase() !== 'P' && this.isLp) {
                        alert("Please uncheck the LP Button");
                    } else if (this.ordNo.charAt(0).toUpperCase() == 'P' && !this.isLp) {
                        alert("Please check the LP Button");
                    } else {
                        const response = await axios.get('/api/getReceivingParts', {
                            params: {
                                ordNo: this.ordNo
                            }
                        })
                        this.originPartList = response.data;
                        //console.log(this.originPartList);

                        let tempList = [];
                        if (this.originPartList.length == 0) {
                            alert("Incorrect Ord No");

                        } else {
                            if (this.isLp) {
                                this.totalQty = this.originPartList.length;
                                const res1 = await axios.get('/api/getReceivingAndScannedParts', {
                                    params: {
                                        ordNo: this.ordNo
                                    }
                                })
                                if (res1) {
                                    for (const part of res1.data) {
                                        if (part.BOX2_QTY == part.SCANNED_QTY) {
                                            part['SCAN_STATUS'] = '1'
                                        } else {
                                            part['SCAN_STATUS'] = '0'
                                        }
                                        if (part.STATUS == '8') {
                                            this.status8 += 1;
                                        }
                                    }

                                    tempList = res1.data;
                                }
                                // } else if (this.ordNo.includes('SAU')) {
                                //     this.receivingType = 'O'
                                //     let invoNo = '';
                                //     let scanStatus = '';
                                //     let custCd = '';
                                //     let lotNo = '';
                                //     for (let part of this.originPartList) {
                                //         const res1 = await axios.get('/api/getInvoNoByBarcode', {
                                //             params: {
                                //                 partData: part
                                //             }
                                //         })
                                //         if (res1) {
                                //             //console.log(res1.data[0]);
                                //             invoNo = res1.data[0].INVO_NO;
                                //             scanStatus = res1.data[0].STATUS;
                                //             custCd = res1.data[0].CUST_CD;
                                //             lotNo = res1.data[0].BOX_LOT;
                                //             part["INVO_NO"] = invoNo;
                                //             part["CUST_CD"] = custCd;
                                //             part["STATUS"] = scanStatus;
                                //             part["BOX_LOT"] = lotNo;
                                //             if (scanStatus != '9') {
                                //                 this.submitStatus = '2';
                                //             }
                                //         }
                                //     }
                                //     for (let part of response.data) {
                                //         if (part.STATUS == '8') {
                                //             this.status8 += 1;
                                //         }
                                //         if (!Object.hasOwnProperty.call(tempList, part.ITMNO.trim())) {
                                //             if (part.STATUS == '9' || part.STATUS == '8') {
                                //                 tempList[part.ITMNO.trim()] = {
                                //                     'ITMNO': part.ITMNO.trim(),
                                //                     'BOX2_QTY': part.BOX2_QTY,
                                //                     'SCANNED_QTY': part.BOX2_QTY,
                                //                     'SCAN_STATUS': '0',
                                //                     'CUST_CD': part.CUST_CD
                                //                 }
                                //             } else {
                                //                 tempList[part.ITMNO.trim()] = {
                                //                     'ITMNO': part.ITMNO.trim(),
                                //                     'BOX2_QTY': part.BOX2_QTY,
                                //                     'SCANNED_QTY': 0,
                                //                     'SCAN_STATUS': '0',
                                //                     'CUST_CD': part.CUST_CD
                                //                 }
                                //             }

                                //         } else {
                                //             if (part.STATUS == '9' || part.STATUS == '8') {
                                //                 tempList[part.ITMNO.trim()].SCANNED_QTY += part.BOX2_QTY;

                                //             }
                                //             tempList[part.ITMNO.trim()].BOX2_QTY += part.BOX2_QTY;
                                //         }
                                //     }
                            } else {

                                this.receivingType = this.ordNo.includes('SAU') ? 'O' : 'N'
                                //console.log(response.data);
                                //console.log(this.receivingType);
                                for (let part of response.data) {
                                    if (part.STATUS == '8') {
                                        this.status8 += 1;
                                    }
                                    if (!Object.hasOwnProperty.call(tempList, part.ITMNO.trim())) {
                                        if (part.STATUS == '9' || part.STATUS == '8') {
                                            tempList[part.ITMNO.trim()] = {
                                                'ITMNO': part.ITMNO.trim(),
                                                'BOX2_QTY': part.BOX2_QTY,
                                                'SCANNED_QTY': part.BOX2_QTY,
                                                'SCAN_STATUS': '0',
                                                'CUST_CD': part.CUST_CD
                                            }

                                        } else {
                                            tempList[part.ITMNO.trim()] = {
                                                'ITMNO': part.ITMNO.trim(),
                                                'BOX2_QTY': part.BOX2_QTY,
                                                'SCANNED_QTY': 0,
                                                'SCAN_STATUS': '0',
                                                'CUST_CD': part.CUST_CD
                                            }
                                        }

                                    } else {
                                        if (part.STATUS == '9' || part.STATUS == '8') {
                                            tempList[part.ITMNO.trim()].SCANNED_QTY += part.BOX2_QTY;

                                        }

                                        tempList[part.ITMNO.trim()].BOX2_QTY += part.BOX2_QTY;
                                    }
                                }
                            }
                            //console.log(this.originPartList);
                            if (!this.isLp) {
                                for (let part of Object.values(tempList)) {
                                    if (part.BOX2_QTY == part.SCANNED_QTY) {
                                        part.SCAN_STATUS = '1'
                                    }
                                }
                                this.partList = Object.values(tempList);
                                this.totalQty = this.originPartList.length;
                                this.countScannedPart();
                                //console.log(this.status8);
                                if (this.totalQty == this.scannedPart) {
                                    if (this.totalQty == this.status8) {
                                        this.submitStatus = '1';
                                    } else {
                                        this.submitStatus = '2';
                                        if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-failed')) {
                                            document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-failed');
                                        }
                                        if (!document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-success')) {
                                            document.getElementsByClassName('scan-screen')[0].classList.add('custom-scan-success')
                                        }
                                        document.getElementsByClassName('status-text')[0].classList.remove('custom-text');
                                        document.getElementsByClassName('status-text')[0].classList.add('custom-text-2');
                                        document.getElementById("status-text").innerText = "COMPLETE";
                                        document.getElementById("status-text2").innerText = "";

                                    }
                                }
                                if (this.submitStatus == '1') {
                                    await this.saveReceivingPerformance();
                                    this.submitStatus == '2';
                                }
                            } else {
                                this.partList = tempList;

                                for (const part of this.partList) {
                                    if (part.SCANNED_QTY == part.BOX2_QTY) {
                                        this.scannedPart += 1;
                                    }
                                }
                                //console.log(this.partList);
                                if (this.totalQty == this.scannedPart) {
                                    if (this.totalQty == this.status8) {
                                        this.submitStatus = '1';
                                    } else {
                                        this.submitStatus = '2';
                                        if (document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-failed')) {
                                            document.getElementsByClassName('scan-screen')[0].classList.remove('custom-scan-failed');
                                        }
                                        if (!document.getElementsByClassName('scan-screen')[0].classList.contains('custom-scan-success')) {
                                            document.getElementsByClassName('scan-screen')[0].classList.add('custom-scan-success')
                                        }
                                        document.getElementsByClassName('status-text')[0].classList.remove('custom-text');
                                        document.getElementsByClassName('status-text')[0].classList.add('custom-text-2');
                                        document.getElementById("status-text").innerText = "COMPLETE";
                                        document.getElementById("status-text2").innerText = "";
                                    }
                                }
                                if (this.submitStatus == '1') {
                                    await this.saveReceivingPerformance();
                                    this.submitStatus == '2';
                                }

                            }





                        }
                    }



                } else {
                    alert('Please Scan Packing List');
                }
                this.$nextTick(() => {
                    if (this.$refs.barcodeInput) {
                        this.$refs.barcodeInput.focus();
                    }
                });

            } catch (err) {
                console.error("Data fetch error: ", err);
                alert("Data fetch error: ", err);
            }

            this.ordNoInput = '';
            this.loading = false;

        },


        countScannedPart() {
            this.loading = true;
            try {
                this.originPartList.forEach(part => {
                    if (part.STATUS == '9' || part.STATUS == '8') {
                        this.scannedPart += 1;
                    }
                })
            } catch (err) {
                console.error("Count parts error: ", err);
            }
            this.loading = false;
        },
        isNumericChar(char) {
            return !isNaN(parseFloat(char)) && isFinite(char);
        },
    }
}
</script>
<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.8);
    z-index: 9999;
}

.spinner {
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top: 4px solid black;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}

.custom-card {
    min-height: 800px;
}

.custom-scan-input {
    color: #495057 !important;
    border: 1px solid #d2d6da !important;
}

.scan-screen {
    display: block;
    transition: 0.5s;
    min-height: 500px;
}

.custom-scan-success {
    background-color: #4CAF50 !important;
    transition: 0.5s;
}

.custom-scan-failed {
    background-color: #F44336 !important;
    transition: 0.5s;
}

.custom-container-input {
    border: 1px solid black;
    height: 40px;
}

.custom-height {
    min-height: 250px;
}

.on-scan {
    border: white 1px solid;
}

.success-screen-part {
    border-top: 2px black solid;
}

.scan-mode-button:hover {
    background: grey;
}

.radio-group-horizontal {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.radio-group-horizontal .v-radio {
    margin-right: 35px;
    /* 각 라디오 버튼 사이의 간격 설정 */
}

.data-table-row td {
    border-left: 1px solid white;
    border-right: 1px solid white !important;
    border-bottom: 1px solid white !important;

}

.data-table-row td {
    border-left: 1px solid white;
    border-right: 1px solid white !important;
    border-bottom: 1px solid white !important;

}

.custom-radio>>>.v-label {
    white-space: nowrap;
    display: inline-block;
}

.custom-text {
    font-size: 13rem !important;
    line-height: 6rem;
    letter-spacing: -0.015625em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
}

.custom-text-2 {
    font-size: 6.9rem !important;
    line-height: 6rem;
    letter-spacing: -0.015625em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
}
</style>